import React, { useState, useEffect } from 'react';
import './ShopTypeScreen.css';

//components
import Nav from '../../Components/Nav/Nav';
import Footer from '../../Components/Footer/Footer';
import ItemCards from '../../Components/ItemCard/ItemCard';

//Data source
import { supplyChairs, supplyCabinets, supplyDecor, supplyTables } from '../../Data';
import { useHistory } from 'react-router';



function ShopTypeScreen(props) {
    const history = useHistory()
    const params = props.match.params.itemType;
        // console.log(supplyChairs)

        const [dataR, setData] = useState([]);
        const getData = () => {
            if (params === 'chairs') setData(supplyChairs);
            else if (params === 'tables') setData(supplyTables);
            else if (params === 'room_decor') setData(supplyDecor);
            else if (params === 'cabinets') setData(supplyCabinets);
            else history.push('/notfound');
        }

        useEffect(() => {
            return getData();
        })

    return (
        <>
            <Nav />
                <div className='shopTypeScreen'>
                    <div className="shop__item__container">
                        <div className="container__content">
                            <ItemCards category={params} data={dataR} />
                        </div>
                    </div>
                    <div className='shop__item__pagination'>

                    </div>
                </div>
            <Footer />
        </>
    )
}

export default ShopTypeScreen
